import {React, useState, forwardRef} from 'react';

import styles from './confirmmodal.module.css';
import constants from '../../../constants';

import { useApiProvider } from '../../../providers/ApiProvider';

const ConfirmModal = forwardRef(function ConfirmDialog(props, ref) {

  return (
    <dialog ref={ref} className={styles.Dialog}>
      <div className={styles.Header}>
        <img className={styles.Icon} src='/icons/warning.svg'></img><br/>
      </div>
      
      <div className={styles.Title}>Are you sure?</div>
      <div className={styles.Subtitle}>{props.message}</div>
      
      <div className={styles.ButtonGroup}>
        <button 
          className={`${styles.Button} ${styles.Highlight}`}
          onClick={(e) => props.onCancel(e)}>No, cancel</button>
        <button 
          className={styles.Button} 
          onClick={(e) => props.onConfirm(e)}>Yes, continue</button>
      </div>
    </dialog>
  )
})

export default ConfirmModal;
